import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import DonationForm from './components/DonationForm';
import AnnReg from './pages/AnnReg';
import AnniversaryDinner from './pages/AnniversaryDinner';
import ThankYou from './pages/ThankYou';
import Success from './pages/Success';
import DonationReport from './pages/DonationReport';
import DonateGrocery from './pages/DonateGrocery';
import ManageGroceryItems from './pages/ManageGroceryItems';

function App() {
  let path = typeof window !== 'undefined' ? window.location.pathname.toLowerCase() : '/';
  // Collapse multiple slashes to a single slash for robust matching (e.g., //hyc -> /hyc)
  path = path.replace(/\/+/, '/');
  const isHome = path === '/' || path === '';
  const isHYC = /^\/hyc(\/+|$)/.test(path);
  const isRMS = /^\/rms(\/+|$)/.test(path);
  // Anniversary Registration page supports /annver (requested), /annreg (back-compat), and /anner (alias)
  const isAnnReg = /^(?:\/annver|\/annreg|\/anner)(\/+|$)/.test(path);
  const isThankYou = /^\/thankyou(\/+|$)/.test(path);
  const isSuccess = /^\/success(\/+|$)/.test(path);
  const isReport = /^\/donationreport(\/+|$)/.test(path);
  const isDonateGrocery = /^\/donate-grocery(\/+|$)/.test(path);
  const isManageGrocery = /^\/manage-grocery(\/+|$)/.test(path);
  const showBanner = isAnnReg; // Hide banner on RMS/HYC donation pages and Report; keep for AnnReg only
  const bannerTitle = isAnnReg
    ? 'Anniversary Registration'
    : (isReport
        ? 'Donation Report'
        : (isHYC ? 'Donation For Harmony Youth Center' : 'Donation For Radha Madhav Society'));
  const subtitle = isAnnReg ? 'RSVP for Anniversary Dinner' : (isReport ? 'View and export donations' : 'Make a secure online contribution');

  // Set document title and favicon based on route
  useEffect(() => {
    if (typeof document !== 'undefined') {
      let pageTitle = 'Donation';
      if (isHome) pageTitle = 'Donation';
      else if (isSuccess) pageTitle = 'Success';
      else if (isThankYou) pageTitle = 'Thank You';
      else if (isAnnReg) pageTitle = 'Anniversary Registration';
      else if (isReport) pageTitle = 'Donation Report';
      else if (isDonateGrocery) pageTitle = 'Donate Groceries';
      else if (isManageGrocery) pageTitle = 'Manage Grocery Items';
      else if (isHYC) pageTitle = 'Harmony Youth Center Donation';
      else if (isRMS) pageTitle = 'Radha Madhav Society Donation';
      else pageTitle = 'Yugal Kunj';
      // Do not override the brand-aware title on Success page; Success.tsx manages its own title
      if (!isSuccess) {
        document.title = `${pageTitle}`;
      }
      const setFavicon = (href: string) => {
        let link = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        link.href = href;
      };
      // Choose brand-specific favicon (use provided external assets)
      const DEFAULT_LOGO = '/logo512.png';
      const RMS_LOGO = 'https://www.radhamadhavsociety.org/assets/images/about/i-logo-2.png';
      const HYC_LOGO = 'https://harmonyyouthcenter.org/Content/images/footer.png';
      let icon = DEFAULT_LOGO;
      if (isHYC) {
        icon = HYC_LOGO;
      } else if (isRMS) {
        icon = RMS_LOGO;
      } else if (isSuccess) {
        // Derive brand from originPath saved by the donation flow
        try {
          const raw = (typeof window !== 'undefined') ? window.sessionStorage.getItem('donationFlowResults') : null;
          if (raw) {
            const parsed = JSON.parse(raw);
            const origin = String(parsed?.originPath || '').toLowerCase();
            if (/^\/hyc(\/|$)/.test(origin)) icon = HYC_LOGO;
            else if (/^\/rms(\/|$)/.test(origin)) icon = RMS_LOGO;
          }
        } catch {}
      }
      // Preload favicon and fallback to default if fetch fails
      try {
        const testImg = new Image();
        testImg.onload = () => setFavicon(icon);
        testImg.onerror = () => setFavicon(DEFAULT_LOGO);
        testImg.src = icon;
      } catch {
        setFavicon(DEFAULT_LOGO);
      }
    }
  }, [isHome, isThankYou, isAnnReg, isHYC, isRMS, isSuccess, isReport, isDonateGrocery]);
  return (
    <div className="App">
      {/* Banner and Navigation (only for donation & registration pages) */}
      {showBanner && (
        <div className="banner">
          <h1>{bannerTitle}</h1>
          <p className="subtitle">{subtitle}</p>
        </div>
      )}

      {/* Donation Form Component */}
      {isHome ? (
        <AnniversaryDinner />
      ) : isSuccess ? (
        <Success />
      ) : isThankYou ? (
        <ThankYou />
      ) : isAnnReg ? (
        <AnnReg />
      ) : isReport ? (
        <DonationReport />
      ) : isDonateGrocery ? (
        <DonateGrocery />
      ) : isManageGrocery ? (
        <ManageGroceryItems />
      ) : isHYC ? (
        <DonationForm
          entity="HYC"
          emailAppName="Donation"
          emailTemplateName="HYCDonation"
          title="Donation for Harmony Youth Center"
        />
      ) : isRMS ? (
        <DonationForm
          entity="RMS"
          emailAppName="Donation"
          emailTemplateName="RMSDonation"
          title="Donation for Radha Madhav Society" />
      ) : (
        <AnniversaryDinner />
      )}
    </div>
  );
}

export default App;
